import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import styled from '@mui/system/styled';
import React from 'react';

export const StyledBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '52px',
  lineHeight: '1rem',
  padding: `0 ${theme.spacing(2.5)}`,
  whiteSpace: 'break-spaces',
}));
export default function RenderHeader(params: any) {
  return (
    <Stack justifyContent="space-between">
      <StyledBox
        sx={(theme) => ({
          borderLeft:
            params.index === 0 ? `1px solid ${theme.palette.grey[200]}` : null,
        })}
      >
        {params.index === 0 ? params.colGrp.name : ''}
      </StyledBox>
      <Box
        left={0}
        position="absolute"
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
        })}
        top="50%"
        width="100%"
      ></Box>
      <StyledBox
        sx={(theme) => ({
          borderLeft:
            params.index === 0 ? `1px solid ${theme.palette.grey[200]}` : null,
        })}
      >
        {params.col.name}
      </StyledBox>
    </Stack>
  );
}
